import React from 'react';
import styled from 'styled-components';

// Testimonials — displayed as text files in My Documents
// Each "file" is a review from a client

const testimonials = [
    {
        filename: 'Review - Smith & Partners.txt',
        content: `From: Sarah Mitchell, Office Manager
Company: Smith & Partners Solicitors
Date: 15th November 2024

Subject: Dead Simple Computing - Annual Review

We've been using Dead Simple Computing for our IT
support for the past 18 months and couldn't be happier.

When we had a ransomware scare last March, Daniel was
on the phone within minutes and had everything locked
down before any data was compromised.

Their Microsoft 365 migration was seamless — they moved
our entire practice management system over a weekend
with zero downtime.

What I appreciate most is they speak plain English.
No jargon, no upselling. Just solid IT support.

Would highly recommend to any small business.

Rating: ★★★★★`,
    },
    {
        filename: 'Review - Berkshire Builders.txt',
        content: `From: Tom Henderson, Director
Company: Berkshire Builders Ltd
Date: 3rd January 2025

Subject: Finally, IT that just works

Before Dead Simple, we were spending half our day
fighting with computers instead of running the business.

Emails not syncing, printers going offline every other
day, and our old server crashing at least once a month.

Dead Simple set us up with proper cloud infrastructure,
sorted our security (we actually passed Cyber Essentials
first time!), and now everything just... works.

Their monthly fee is less than what we were spending on
emergency call-outs from our old IT bloke.

Best business decision we made last year.

Rating: ★★★★★`,
    },
    {
        filename: 'Review - Thames Valley Dental.txt',
        content: `From: Dr. Amy Chen, Practice Owner
Company: Thames Valley Dental Practice
Date: 22nd September 2024

Subject: GDPR compliant at last!

As a dental practice, we handle extremely sensitive
patient data and were terrified about GDPR compliance.

Dead Simple Computing did a full security audit,
set up encrypted backups, implemented proper access
controls, and trained all our staff.

They even helped us with our Information Commissioner's
Office registration and our data protection impact
assessment.

Our CQC inspector was genuinely impressed with our
IT security setup. That never happens.

Can't recommend them highly enough.

Rating: ★★★★★`,
    },
    {
        filename: 'Review - Reading Recruitment.txt',
        content: `From: James Wright, Founder
Company: Reading Recruitment Solutions
Date: 8th February 2025

Subject: Saved us from disaster

I'll keep this brief because the story speaks for itself:

Monday morning, 8:45am. Entire office can't log in.
Called Dead Simple at 8:47am. Daniel answered immediately.
By 9:15am, everyone was working again.

Turned out our domain controller had failed overnight.
They had it rebuilt from backup before most of the
team had even finished their coffee.

Previous IT company would have taken three days and
charged us emergency rates. Dead Simple had it sorted
in 30 minutes as part of our standard support contract.

That's the difference.

Rating: ★★★★★`,
    },
];

function Testimonials() {
    const [selected, setSelected] = React.useState(0);

    return (
        <Container>
            <Sidebar>
                <SidebarTitle>📁 Client Reviews</SidebarTitle>
                {testimonials.map((t, i) => (
                    <FileItem
                        key={i}
                        active={i === selected}
                        onClick={() => setSelected(i)}
                    >
                        📄 {t.filename}
                    </FileItem>
                ))}
            </Sidebar>
            <Content>
                <Toolbar>
                    <ToolbarBtn>File</ToolbarBtn>
                    <ToolbarBtn>Edit</ToolbarBtn>
                    <ToolbarBtn>View</ToolbarBtn>
                    <ToolbarBtn>Help</ToolbarBtn>
                </Toolbar>
                <TextArea readOnly value={testimonials[selected].content} />
            </Content>
        </Container>
    );
}

const Container = styled.div`
  height: 100%;
  display: flex;
  font-family: Tahoma, sans-serif;
  font-size: 11px;
`;

const Sidebar = styled.div`
  width: 200px;
  background: #EBF0F9;
  border-right: 1px solid #ACA899;
  overflow-y: auto;
  padding: 4px;
  flex-shrink: 0;
`;

const SidebarTitle = styled.div`
  font-weight: bold;
  padding: 6px 4px;
  border-bottom: 1px solid #ACA899;
  margin-bottom: 4px;
`;

const FileItem = styled.div`
  padding: 4px 6px;
  cursor: pointer;
  border-radius: 2px;
  background: ${({ active }) => active ? '#316AC5' : 'transparent'};
  color: ${({ active }) => active ? '#fff' : '#000'};
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    background: ${({ active }) => active ? '#316AC5' : '#D8E4F8'};
  }
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Toolbar = styled.div`
  display: flex;
  background: #ECE9D8;
  border-bottom: 1px solid #ACA899;
  padding: 2px;
`;

const ToolbarBtn = styled.div`
  padding: 2px 8px;
  cursor: pointer;
  &:hover { background: #316AC5; color: #fff; }
`;

const TextArea = styled.textarea`
  flex: 1;
  border: none;
  outline: none;
  resize: none;
  font-family: 'Lucida Console', 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.5;
  padding: 12px;
  background: #fff;
  color: #000;
`;

export default Testimonials;
